import React from 'react';
import {Title, Text} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {HistoryTabs} from './Tabs';
import {StatusesTabContent} from './StatusesTabContent';
import {ChangesTabContent} from './ChangesTabContent';
import Loader from '../../Common/components/Loader';
import styles from '../styles/historyHeader.module.scss';
import texts from '../../texts';
import {Record, Form} from '../../../../../../stores/Form';
import {StatusData} from '../../../../../../_legacy/Form/types';
import {SettingsPanelCol} from '../../Common/consts';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type HistoryProps = {
    records: Record[];
    parentTitle: string;
    mainFormValue: string;
    isLoading: boolean;
    statusColorMap: StatusData[];
    shouldFetchMore: boolean;
    form: Form;
    sidePanelSubforms: any;
    switchSubform: (subformType: priority.netitems.form.SubformType) => void;
    isLegacyStore: boolean;
    enabledCols: string[];
    applySettings: (cols: SettingsPanelCol[]) => Promise<void>;
    subformType: priority.netitems.form.SubformType;
    fastSearchQuery: string;
};

export const History = ({
    records,
    parentTitle,
    mainFormValue,
    isLoading,
    statusColorMap,
    shouldFetchMore,
    form,
    sidePanelSubforms,
    switchSubform,
    isLegacyStore,
    enabledCols,
    applySettings,
    subformType,
    fastSearchQuery
}: HistoryProps) => {
    const statusesSubformName = sidePanelSubforms[priority.netitems.form.SubformType.StatusLog];
    const changesSubformName = sidePanelSubforms[priority.netitems.form.SubformType.ChangeLog];

    return (
        <>
            <div className={styles.header}>
                <div>
                    <Title
                        text={texts.history}
                        skin={'h4'}
                        textColor="primary-700"
                        {...createDataTestId(`panel-header-title`, true)}
                    />
                    <Text
                        skin={'paragraph-2'}
                        textColor="secondary-500"
                        {...createDataTestId(`panel-form-title`, true)}
                    >
                        {`${parentTitle} ${mainFormValue}`}
                    </Text>
                </div>
                <HistoryTabs
                    form={form}
                    isLoading={isLoading}
                    statusesSubformName={statusesSubformName}
                    changesSubformName={changesSubformName}
                    switchSubform={switchSubform}
                />
            </div>
            {isLoading ? (
                <Loader />
            ) : form?.ename === statusesSubformName ? (
                <StatusesTabContent
                    statuses={records}
                    shouldFetchMore={shouldFetchMore}
                    statusColorMap={statusColorMap}
                    isLegacyStore={isLegacyStore}
                    enabledCols={enabledCols}
                    applySettings={applySettings}
                    subformType={subformType}
                />
            ) : form?.ename === changesSubformName ? (
                <ChangesTabContent
                    logs={records}
                    shouldFetchMore={shouldFetchMore}
                    fastSearchQuery={fastSearchQuery}
                    isLegacyStore={isLegacyStore}
                    enabledCols={enabledCols}
                    applySettings={applySettings}
                    subformType={subformType}
                />
            ) : null}
        </>
    );
};
